export default __webpack_public_path__ + "static/media/workpadTAB.5c525fd0.jpeg";